<template>
  <div class="row text-sm text-neutral q-mb-xxl">
    <div class="col-2">
      <span class="text-neutral-80"> Customer </span>
    </div>
    <div class="col-4">
      <span>
        {{ userDetails?.inv?.po_info?.buyer_name || "-" }}
      </span>
      <div>
        <span class="text-xs text-neutral-70">
          {{ userDetails?.inv?.po_info?.buyer_gstin || "-" }}
        </span>
      </div>
    </div>
    <div class="col-2">
      <span class="text-neutral-80"> Date </span>
    </div>
    <div class="col-4">
      <span>
        {{ formatDate(userDetails?.date, "DD MMM YYYY") }}
      </span>
    </div>
    <div v-if="module === 'cn'" class="col-2">
      <span class="text-neutral-80"> Vehicle No. </span>
    </div>
    <div v-if="module === 'cn'" class="col-4">
      <span>
        {{ userDetails?.vehicle_number }}
      </span>
    </div>
    <div class="col-6"></div>
  </div>
</template>
<script setup>
import { date } from "quasar";

const { formatDate } = date;

defineProps({
  userDetails: {
    type: Object,
    required: true,
  },
  source: {
    type: String,
    default: "",
  },
  module: {
    type: String,
    default: "cn",
  },
});
</script>
